
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useIsMobile } from '@/hooks/use-mobile';

interface TripNavTabsProps {
  currentTab: string;
  onTabChange: (value: string) => void;
  tripId: string;
}

const TripNavTabs: React.FC<TripNavTabsProps> = ({ currentTab, onTabChange, tripId }) => {
  const isMobile = useIsMobile();
  
  return (
    <Tabs 
      defaultValue={currentTab === 'fun' ? 'itinerary' : currentTab} 
      className="w-full mb-8" 
      onValueChange={value => onTabChange(`/trips/${tripId}/${value}`)}
    >
      {isMobile ? (
        <TabsList className="bg-muted/50 mb-6 p-1 mx-auto max-w-4xl w-full grid grid-cols-1 gap-1">
          <div className="grid grid-cols-2 gap-1 mb-1">
            <TabsTrigger value="itinerary" className="data-[state=active]:bg-white data-[state=active]:shadow-sm data-[state=active]:text-[#0A3D62] font-medium text-sm sm:text-base">
              Itinerary
            </TabsTrigger>
            <TabsTrigger value="travel" className="data-[state=active]:bg-white data-[state=active]:shadow-sm text-sm sm:text-base">
              Travel
            </TabsTrigger>
          </div>
          
          <div className="grid grid-cols-2 gap-1 mb-1">
            <TabsTrigger value="expenses" className="data-[state=active]:bg-white data-[state=active]:shadow-sm text-sm sm:text-base">
              Expenses
            </TabsTrigger>
            <TabsTrigger value="group" className="data-[state=active]:bg-white data-[state=active]:shadow-sm text-sm">
              Chat/Polls
            </TabsTrigger>
          </div>
          
          <div className="grid grid-cols-2 gap-1">
            <TabsTrigger value="memories" className="data-[state=active]:bg-white data-[state=active]:shadow-sm text-sm">
              Memories
            </TabsTrigger>
            <TabsTrigger value="assistant" className="data-[state=active]:bg-white data-[state=active]:shadow-sm text-sm">
              Assistant
            </TabsTrigger>
          </div>
        </TabsList>
      ) : (
        <TabsList className="bg-muted/50 mb-6 p-1 mx-auto max-w-4xl w-full grid grid-cols-6 gap-1">
          <TabsTrigger value="itinerary" className="data-[state=active]:bg-white data-[state=active]:shadow-sm data-[state=active]:text-[#0A3D62] font-medium text-sm sm:text-base">
            Itinerary
          </TabsTrigger>
          <TabsTrigger value="travel" className="data-[state=active]:bg-white data-[state=active]:shadow-sm text-sm sm:text-base">
            Travel
          </TabsTrigger>
          <TabsTrigger value="expenses" className="data-[state=active]:bg-white data-[state=active]:shadow-sm text-sm sm:text-base">
            Expenses
          </TabsTrigger>
          <TabsTrigger value="group" className="data-[state=active]:bg-white data-[state=active]:shadow-sm text-base">
            Chat/Polls
          </TabsTrigger>
          <TabsTrigger value="memories" className="data-[state=active]:bg-white data-[state=active]:shadow-sm text-base">
            Memories
          </TabsTrigger>
          <TabsTrigger value="assistant" className="data-[state=active]:bg-white data-[state=active]:shadow-sm text-base">
            Assistant
          </TabsTrigger>
        </TabsList>
      )}
    </Tabs>
  );
};

export default TripNavTabs;
